// Incorporate into getValue.
import { Store } from "../../infinity-store/interfaces/Store.interface";
import { getValue } from "../../infinity-store/methods/getValue";

/**
 * [Pure] Determine value to use in rule.
 * @param store - Store to get composed values from.
 * @param value - Initial value.
 */
export function ruleValue(store: Store, value: any): any {
    let preset = (store && store.preset) || {};
    if (typeof value === "string" && value[0] === "#") {
        let presetValue = getValue(value.slice(1), preset);
        let storeValue = getValue(value.slice(1), store);
        value = presetValue !== undefined ? presetValue : storeValue;
    }
    if (typeof value === "string" && value.match(/^\d+(?:\.\d*)?$/)) value = parseInt(value);   // Parse integers.
    return value;
}
